<template>
  <gj-modal
      size="full"
      :visible.sync="modalVisible"
      :confirmLoading="confirmLoading"
      @cancel="cancel"
      @confirm="confirm">
    <template #header>新增广告组</template>
    <template #content>
      <el-form
          ref="form"
          :model="form"
          style="padding: 0 10px;">
        <app-add-title>广告组</app-add-title>
        <app-base-info
            :form="form.baseInfoForm"
            campaignTargetType
            groupInput
        ></app-base-info>
        
        <el-divider></el-divider>
  
        <app-add-title>推广的商品</app-add-title>
        <app-product-picker
            :form="form.productPickerForm"
            title="商品"
        ></app-product-picker>
  
        <el-divider></el-divider>
  
        <app-add-title>竞价</app-add-title>
        <app-bid-picker
            :form="form"
        ></app-bid-picker>
  
        <el-divider></el-divider>
  
        <app-add-title>投放商品</app-add-title>
  
        <app-product-target-picker
            :form="form.productTargetPickerForm"
            :default-bid="form.defaultBid"
            title="商品投放"
        ></app-product-target-picker>
        
      </el-form>
    </template>
  </gj-modal>
</template>

<script>
  import {modalMixIn} from "../../../../../../../../minxins";
  import {spMatchType, spNegMatchType} from "../../../../../common/options";
  import AppBaseInfo from "../common/base-info";
  import AppAddTitle from "../common/title";
  import AppProductPicker from "../common/product-picker";
  import {AdBidTypeEnum, AdTargetTypeEnum} from "../../../../../common/enum";
  import AppBidPicker from "../common/bid-picker";
  import AppProductTargetPicker from "../common/product-target-picker";

  export default {
    name: "app-add-sd-ad-group",
    mixins: [modalMixIn],
    components: {
      AppProductTargetPicker, AppBidPicker,
      AppProductPicker, AppAddTitle, AppBaseInfo
    },
    data() {
      return {
        form: {
          baseInfoForm: {
            campaignId: null,
            groupName: null,
          },
          productPickerForm: {
            items: []
          },
          negKeywordPickerForm: {
            items: [],
            matchType: spNegMatchType[0].id
          },
          negTargetPickerForm: {
            items: []
          },
          keywordPickerForm: {
            items: [],
            matchType: spMatchType[0].id
          },
          targetType: AdTargetTypeEnum.keyword,
          bidPickerForm: {
            bidType: AdBidTypeEnum.default,
            defaultBid: null,
            items: [],
          },
          productTargetPickerForm: {
            items: [],
            matchType: spMatchType[0].id
          }
        },
        spNegMatchType: spNegMatchType
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import "../../../../../common/common";

</style>
